import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { PasswordState, PasswordStateLevel } from '../../interfaces/password-state.interface';

@Component({
  selector: 'lgn-password-state',
  templateUrl: './password-state.component.html',
  styleUrls: ['./password-state.component.scss'],
  animations: [
    trigger('barChange', [
      state('in', style({ width: '{{ inWidth }}' }), { params: { inWidth: '0%' } }),
      state('out', style({ width: '{{ outWidth }}' }), { params: { outWidth: '0%' } }),
      transition('* <=> *', animate('400ms ease-in-out')),
    ]),
    trigger('textChange', [
      transition('* => *', [
        style({
          color: '#D0D0D0',
          opacity: 0.3,
          transform: 'translateX(40%)',
        }),
        animate(
          '350ms ease-in',
          style({
            color: '#000000',
            opacity: 1,
            transform: 'translateX(0)',
          })
        ),
      ]),
    ]),
  ],
})
export class PasswordStateComponent {
  passwordState: PasswordState;
  passwordLevel = '0';
  oldpwasswordLevel = '20';
  slidingDoorValue: 'out' | 'in' = 'in';
  inWidth = '10%';
  outWidth = '10%';

  @Input() set state(dat: PasswordState) {
    this.passwordState = dat;

    if (this.passwordLevel !== this.getLavel(this.passwordState.level)) {
      this.slidingDoorValue = this.slidingDoorValue === 'in' ? 'out' : 'in';

      this.oldpwasswordLevel = this.passwordLevel;
      this.passwordLevel = this.getLavel(this.passwordState.level);

      if (this.slidingDoorValue === 'in') {
        this.inWidth = this.passwordLevel + '%';
        this.outWidth = this.oldpwasswordLevel + '%';
      } else {
        this.inWidth = this.oldpwasswordLevel + '%';
        this.outWidth = this.passwordLevel + '%';
      }
    }
    this.passwordLevel = this.getLavel(this.passwordState.level);
  }

  getLavel(level: PasswordStateLevel): string {
    return level.toString().slice(6);
  }
}
